import { call, put, all, takeEvery } from 'redux-saga/effects'
import { openModal } from 'reducers/messageReducer';
import { errorConfirmInit, setErrorConfirmInitResult } from 'reducers/selectionFileUploadErrorConfirmReducer';
import { initApi } from 'apis/MCBPS050Api';

function* errorConfirmInitSaga(action: ReturnType<typeof errorConfirmInit>) {
  try {
    const data = yield call(initApi, action.payload)
    yield put(setErrorConfirmInitResult(data))
  } catch (error) {
    yield put(openModal(error.message))
  }
}

export default function* selectionFileUploadErrorConfirmSaga() {
  yield all([
    takeEvery(errorConfirmInit, errorConfirmInitSaga),
  ])
}